(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal','ProjectService', 'Auth', 'JhiLanguageService', '$translate', '$localStorage', '$q'];

    function SettingsController (Principal,ProjectService, Auth, JhiLanguageService, $translate, $localStorage, $q) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        loadComboBoxValues();

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                fax: account.fax,
                phone: account.phone,
                login: account.login,
                title: account.title,
                salutation: account.salutation,
                projectID :  $localStorage.project
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        }, function (error) {
            // Ignore unhandled error
            return $q.reject(error);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                }, function (error) {
                    // Ignore unhandled error
                    return $q.reject(error);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                }, function (error) {
                    // Ignore unhandled error
                    return $q.reject(error);
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
        function loadComboBoxValues () {
            ($localStorage.salutations !== undefined) ? vm.salutations = $localStorage.salutations : ProjectService.loadSalutations($localStorage.project).then(successSalutations, error);
            ($localStorage.academictitles !== undefined) ? vm.academictitles = $localStorage.academictitles : ProjectService.loadAcademicTitles($localStorage.project).then(successAcademicTitles, error);
        }

        function error(response) {
            $log.debug('SettingsController | ERROR:', response);
        }

        function successSalutations(response) {
            vm.salutations = response.data;
            translateComboBoxValues(vm.salutations);
            $localStorage.salutations = vm.salutations;
        }

        function successAcademicTitles(response) {
            vm.academictitles = response.data;
            translateComboBoxValues(vm.academictitles);
            $localStorage.academictitles = vm.academictitles;
        }

        function translateComboBoxValues(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.translations[vm.lang];
                values.push(value);
            });
            array = values;
        }
    }
})();
